module.exports = __webpack_public_path__ + "static/drVibes-41189cc4b38b33c70b18a8bee6dc02ca.jpg";